import { useRoutes } from "react-router-dom";
import Container from "./container";
import Login from "./login";
import Register from "./register";
import Recover from "./recover";
import ResetPassword from "./resetPassword";
import CustomerPhoto from "./customerPhoto";

export default function PublicRoot() {
  let routes = useRoutes([
    {
      path: "/",
      element: <Container />,
      children: [
        {
          path: "/",
          element: <Login />,
        },
        {
          path: "*",
          element: <Login />,
        },
        {
          path: "/login",
          element: <Login />,
        },
        {
          path: "/register",
          element: <Register />,
        },
        {
          path: "/recover",
          element: <Recover />,
        },
        {
          path: "/recover/:token/:email",
          element: <ResetPassword />,
        },
        { path: "customerPage/:type/:id", element: <CustomerPhoto /> },
      ],
    },
  ]);

  return routes;
}
